import { useService } from '@policoders/di';
import { FormInput, SelectInput, SubModalService } from '@policoders/ds';
import { useEffect, useState } from 'react';

import { OrderStatus } from './order-status.enum';
import PurchaseOrderItemForm from './purchase-order-item.form';
import {
  PurchaseOrder,
  PurchaseOrderItem,
  PurchaseOrderItemValidator,
} from './purchase-order.model';
import PurchaseOrderRepository from './purchase-order.repository';

type IProps = {
  data: PurchaseOrder;
  onChange: (data: PurchaseOrder) => void;
};

const PurchaseOrderForm = ({ data, onChange }: IProps) => {
  const [state, setState] = useState<PurchaseOrder>(data);
  const [currentLine, setCurrentLine] = useState<PurchaseOrderItem>(new PurchaseOrderItem());
  const repository = useService<PurchaseOrderRepository>('PurchaseOrderRepository');
  const subModal = useService<SubModalService>('SubModalService');

  useEffect(() => {
    data.id &&
      repository.getById(data.id).then(value => {
        setState(value ?? data);
      });
  }, [data, repository]);

  useEffect(() => {
    onChange && onChange(state);
  }, [onChange, state]);

  const handleChange = (e: any) => {
    console.log('handleChange', e.target.name, e.target.value);
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const orderStatus = () => {
    var items = Object.keys(OrderStatus);
    var values = Object.values(OrderStatus);
    return [
      { label: '', value: '' },
      ...items.map((item, i) => ({
        label: item.replace('_', ' '),
        value: values[i],
      })),
    ];
  };

  const handleAddItem = () => {
    const item = new PurchaseOrderItem();
    console.log('handleAddItem', item);
    setCurrentLine(item);
    subModal
      .config({
        size: 'large',
        title: 'adicionar item',
        buttonOkLabel: 'Ok',
        children: () => <PurchaseOrderItemForm data={item} onChange={setCurrentLine} />,
      })
      .open();
  };

  useEffect(() => {
    const validator = new PurchaseOrderItemValidator();
    if (currentLine && validator.validate(currentLine)) {
      console.log('Adding item:', currentLine);
      setState(prevState => ({
        ...prevState,
        items: [
          ...prevState.items.filter(x => x.productName !== currentLine.productName),
          currentLine,
        ],
      }));
    }
  }, [currentLine]);

  return (
    <div>
      <div className="row">
        <div className="col-7">
          <FormInput
            type="text"
            label="Fornecedor"
            field="supplierName"
            placeholder="Nome do fornecedor"
            value={state.supplierName}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <FormInput
            type="date"
            label="Data do pedido"
            field="orderDate"
            value={state.orderDate}
            onChange={handleChange}
          />
        </div>
        <div className="col">
          <SelectInput
            label="Tipo"
            field="type"
            value={state.status}
            options={orderStatus()}
            onChange={handleChange}
          />
        </div>
      </div>
      <div>
        <div>
          Itens
          <button
            onClick={handleAddItem}
            type="button"
            className="btn btn-secondary btn-sm float-end">
            +
          </button>
        </div>
        <table className="table table-sm table-hover">
          <thead>
            <tr className="table-light">
              <th>Produto</th>
              <th>Quantidade</th>
              <th>Unidade de Medida</th>
              <th>Preço Unitário</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {state.items.map((item, index) => (
              <tr key={index}>
                <td>{item.productName}</td>
                <td>{item.quantity}</td>
                <td>{item.measureUnit}</td>
                <td>{item.unitPrice?.toFixed(2)}</td>
                <td>{item.totalPrice?.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={4} className="text-end">
                <strong>Total:</strong>
              </td>
              <td>
                <strong>
                  {state.items.reduce((acc, item) => acc + (item.totalPrice ?? 0), 0).toFixed(2)}
                </strong>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default PurchaseOrderForm;
